import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import IMobxProviderContext from '../interfaces/IMobxProviderContext';
import { IDataItemStore } from '../entityStores/genericStores/DataItemStore';

const useDataItemStore = (): IDataItemStore | undefined => (useContext<IMobxProviderContext>(MobXProviderContext as any) as any)?.rootStore?.dataItemStore;

export default useDataItemStore;
